module.exports = __webpack_public_path__ + "fonts/Nunito-400-latin-ext9.c321139.woff2";